export const SHOW_DOWNLOAD_PROOF = "APP/UI/PORTAL/SHOW_DOWNLOAD_PROOF";
export const HIDE_PDF_DOWNLOAD = "APP/UI/PORTAL/HIDE_PDF_DOWNLOAD";
